export function createDownloadLink(data: Blob, fileName: string, extensionName: string) {
  const url = URL.createObjectURL(data)
  const link = document.createElement('a')
  const name = fileName.replace(/\s/g, '_').toLowerCase()
  link.href = url
  link.setAttribute('download', `${name.replace(/\W/g, '')}${extensionName}`)
  return link
}

export function triggerDownload(link: HTMLAnchorElement) {
  document.body.appendChild(link)
  link.click()
  link.remove()
}
